import React from 'react';
// material ui
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import { withTranslation } from 'react-i18next';
import { Dialog, DialogActions, DialogTitle } from "@mui/material";
import theme from '../../config/theme'

const styles = theme => ({
    saveBtn:{
        cursor:'pointer',
        backgroundColor:'#0F467A',
        color:'#fff',
        fontWeight:'bold',
        padding:'3px 10px',
        fontSize:'14px',
        borderRadius:'5px',
        textTransform:'capitalize',
        textAlign: 'center',
        lineHeight: 2.5,
        marginTop: '10px',
        [theme.breakpoints.between('xs','md')]:{
            fontSize:'10px',
        }
    },

    actionDialog:{
        justifyContent:'space-between',
        alignSelf:'flex-end',
        [theme.breakpoints.between('xs','md')]:{
            flexDirection:'column'
        }
    },

    dialogRoot:{
        zIndex: '1111111 !important'
    },
})

class ProccedDialog extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
    }

    handleClose = () => {
        this.props.onClose();
    }
    
    render() {
        let { classes, tReady, dispatch, redirectRenew,t,isRTL, ...other } = this.props;
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const fontFamily = isRTL === 'ar' ? ar : en;
    return (
        (<React.Fragment>
            <Dialog
                {...other}
                classes={{root:classes.dialogRoot}}
                aria-labelledby="alertDialog"
                style={{fontFamily:"'Poppins', sans-serif"}}
                fullWidth={true}
                dir={isRTL === 'ar' ? 'rtl' : 'ltr'}
                maxWidth='sm'>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                        <DialogTitle id="alert-dialog-title" style={{fontFamily,fontWeight:'bold !important'}}>{t('booking.dialog.proc-title')}</DialogTitle>
                </ThemeProvider>
            </StyledEngineProvider>
                <DialogActions classes={{root: classes.actionDialog}}>
                    <div className={classes.saveBtn} onClick={redirectRenew} style={{fontFamily}}>{t('booking.dialog.renewBtn')}</div>
                    <div className={classes.saveBtn} onClick={this.handleClose} style={{fontFamily}}>{t('booking.dialog.newBook')}</div>
                </DialogActions>
            </Dialog>
        </React.Fragment>)
    );}
}

export default withStyles(styles)(withTranslation('common')(ProccedDialog));